import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { useSearchRecipients } from 'chat/members/queries/recipients'
import { ProcessingMemberListView } from 'chat/members/views/processing_member_list'
import React, { useLayoutEffect, useState } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderButton } from 'shared/header/header_button'
import { useUser } from 'users/queries/detail'
import { SelectMembersView } from '../../../members/views/select'
import { useCreateCustomGroup } from '../context'
import { ChooseMembersScreenProps } from '../stack/types'

export function ChooseMembersScreen({
  navigation,
  route,
}: ChooseMembersScreenProps) {
  const { data: user } = useUser()
  const companyId = route.params?.companyId
  const {
    members,
    setMembers,
    selectedMemberAliases,
    setSelectedMemberAliases,
  } = useCreateCustomGroup()
  const { theme } = useTheme()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const searchRecipientsQuery = useSearchRecipients(searchTerm, companyId)
  const disableAliasSelection = searchTerm.length > 0
  useLayoutEffect(() => {
    showHeaderButton({
      navigation,
      theme,
      title: t('next'),
      onPress: () => {
        navigation.navigate('create_group', { companyId })
      },
      position: 'right',
      disabled:
        Object.keys(members).length === 0 &&
        selectedMemberAliases?.length === 0,
    })
  }, [companyId, members, navigation, selectedMemberAliases?.length, theme])

  if (searchRecipientsQuery.isLoading) {
    return <ProcessingMemberListView />
  }

  return (
    <StatusBoundary
      isLoading={searchRecipientsQuery.isLoading}
      error={searchRecipientsQuery.error}
      loadingMessage={t('loadingRecipientsText')}
    >
      <SelectMembersView
        disabledMemberIds={user ? [user.id] : []}
        recipients={searchRecipientsQuery.data}
        selectedMembers={members}
        onMembersSelected={setMembers}
        onMemberAliasesSelected={setSelectedMemberAliases}
        memberAliases={selectedMemberAliases}
        searchText={searchTerm}
        setSearchText={setSearchTerm}
        disableAliasSelection={disableAliasSelection}
      />
    </StatusBoundary>
  )
}
